export enum RoutePaths {
  Root = '/',
}
